<template>
  <b-row class="contact-basket-item">
    <b-col col md="2" class="image">
      <img :src="`/static/images/avatars/main${contact.avatar || 1}.png`" class="contact-picture"/>
    </b-col>

    <b-col v-if="isRecruiter" col md="8">
      <span class="jobTitle" v-if="contact.latestEmployment && contact.latestEmployment.title">{{contact.latestEmployment.title}}</span>
      <span class="jobTitle" v-else>(Not known)</span>
      <span class="company secondary-color" v-if="contact.latestEmployment && contact.latestEmployment.companyName">Currently at <b>{{contact.latestEmployment.companyName}}</b></span>
      <span class="company secondary-color" v-else>&nbsp;</span>
    </b-col>
    <b-col v-else col md="8">
      <span class="jobTitle" v-if="contact.fullName">{{contact.fullName}}</span>
      <span class="jobTitle" v-else>(Not known)</span>
      <span class="company secondary-color" v-if="contact.latestEmployment && contact.latestEmployment.companyName">Currently at <b>{{contact.latestEmployment.companyName}}</b></span>
      <span class="company secondary-color" v-else>&nbsp;</span>
    </b-col>

    <b-col col md="2" v-if="$listeners.removeContact">
      <a href="#" @click.prevent="() => $emit('removeContact')">
        <font-awesome-icon icon="times-circle" class="float-right red"/>
      </a>
    </b-col>

  </b-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'ContactsBasketItem',
  components: {
    FontAwesomeIcon,
  },
  props: {
    contact: {
      type: Object,
      validate(contact) {
        return contact && contact.id;
      },
    },
  },
  computed: {
    ...mapRoot([ 'isRecruiter' ]),
  },
};
</script>

<style lang="scss">
.contact-basket-item {
  padding-bottom: 0.7rem;
  padding-top: 0.7rem;

  img {
    margin-right: 1rem;
    height: 3em;
    width: 3em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/basketItem.vue